import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import Service from '../../api/Service';
import * as consts from '../../utils/constants/url';

export const sendResetValidationCode = createAsyncThunk(
  'reset/sendResetValidationCode',
  async (payload, thunkAPI) => {
    try {
      const response = await Service.post(
        consts.ENDPOINT_TENANT_FORGOTTEN,
        payload
      );
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue({
        error: {
          code: e.code,
          message: e.message,
        },
      });
    }
  }
);

export const checkResetToken = createAsyncThunk(
  'reset/checkResetToken',
  async (payload, thunkAPI) => {
    try {
      const response = await Service.post('tenant/verify/reset', payload);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue({
        error: {
          code: e.code,
          message: e.message,
        },
      });
    }
  }
);

const initialState = {
  data: {},
  /**
   * request | verify | reset
   */
  step: 'request',
  via: 'txt',
  done: false,
};

export const resetSlice = createSlice({
  name: 'reset',
  initialState,
  reducers: {
    setData: (state, {payload}) => ({
      ...state,
      data: {
        ...state.data,
        ...payload,
      },
    }),
    reset: () => ({
      ...initialState,
    }),
    resetData: state => ({
      ...state,
      data: {},
    }),
    setStep: (state, {payload}) => ({
      ...state,
      step: payload,
    }),
    setVia: (state, {payload}) => ({
      ...state,
      via: payload,
    }),
    setDone: (state, {payload}) => ({
      ...state,
      done: payload,
    }),
  },
});

export const resetState = state => state.reset;

export const {reset, resetData, setData, setDone, setStep, setVia} =
  resetSlice.actions;

export default resetSlice.reducer;
